import { render, staticRenderFns } from "./freeBox.vue?vue&type=template&id=5aa5c50c"
import script from "./freeBox.vue?vue&type=script&lang=js"
export * from "./freeBox.vue?vue&type=script&lang=js"
import style0 from "./freeBox.vue?vue&type=style&index=0&id=5aa5c50c&prod&scoded=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports